import axios from 'axios'

const API_VERSION = process.env.REACT_APP_API_VERSION
const API_URL = process.env.REACT_APP_API_URL
const BASE_URL = `${API_URL}/${API_VERSION}`

class PostHogService {
  private static instance: PostHogService
  private initialized: boolean = false
  private distinctId: string = ''

  static getInstance(): PostHogService {
    if (!PostHogService.instance) {
      PostHogService.instance = new PostHogService()
    }
    return PostHogService.instance
  }

  init(): void {
    this.initialized = true
  }

  isInitialized(): boolean {
    return this.initialized
  }

  identify(userId: string): void {
    if (!this.initialized) return
    this.distinctId = userId
    try {
      axios
        .post(`${BASE_URL}/analytics/actions`, {
          action: 'identify',
          distinct_id: userId,
        })
        .catch(() => {})
    } catch {
      // Silently fail
    }
  }

  alias(alias: string, distinctId: string): void {
    if (!this.initialized) return
    try {
      axios
        .post(`${BASE_URL}/analytics/actions`, {
          action: 'alias',
          distinct_id: distinctId,
          alias: alias,
        })
        .catch(() => {})
    } catch {
      // Silently fail
    }
  }

  capture(eventName: string, properties: Record<string, unknown>): void {
    if (!this.initialized) return
    try {
      const distinctId = (properties.user_id as string) || this.distinctId
      if (!distinctId) return

      axios
        .post(`${BASE_URL}/analytics/events`, {
          event: eventName,
          distinct_id: distinctId,
          properties: properties,
        })
        .catch(() => {})
    } catch {
      // Silently fail
    }
  }

  reset(): void {
    this.distinctId = ''
  }
}

export {PostHogService}
